"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _getMoment = _interopRequireDefault(require("./getMoment"));

var utcOffset = '+00:00';

function formatDate(date, formatString, isUTC) {
  var momentDate = (0, _getMoment["default"])(date);

  if (isUTC) {
    momentDate = momentDate.utcOffset(utcOffset);
  }

  return momentDate.format(formatString);
}

module.exports = formatDate;